<template>
  <div
    style="margin-top: 12px;text-align: center;">
    <span
      class="return-btn"
      @click="handleBack">
      {{ $t('返回') }}
    </span>
  </div>
</template>

<script>
export default {
  data () {
    return {
    }
  },
  methods: {
    handleBack () {
      this.$emit('click')
    }
  }
}
</script>

<style scoped lang="less">
.return-btn {
  display: inline-block;
  font-size: 12px;
  color: #5A607F;
  line-height: 14px;
  cursor: pointer;
  user-select: none;
  &:hover {
    color: #4A6AFF;
  }
}
</style>
